/*
  RENKA withdrawal button ("Vertrag widerrufen", EU 2023/2673): two-step form.
  Step 1 collects name, email, order number and date; step 2 shows the declaration and asks for
  confirmation; then the Shopify contact form is sent. Without JavaScript the form is a single step.
  Used on /pages/vertrag-widerrufen (sections/renka-withdrawal.liquid) and inside the station's legal
  overlay (assets/renka-station.js imports wireWithdrawal and passes inline: true).
*/

export function wireWithdrawal(scope = document, { inline = false } = {}) {
  scope.querySelectorAll('[data-renka-withdrawal]').forEach((box) => {
    const form = box.querySelector('form');
    if (!form || box.dataset.wired) return;
    box.dataset.wired = '1';
    const step1 = box.querySelector('.wd-step1'), step2 = box.querySelector('.wd-step2');
    const summary = box.querySelector('[data-wd-summary]'), body = box.querySelector('[data-wd-body]');
    const msg = box.querySelector('.wd-msg'), next = box.querySelector('[data-wd-next]');
    if (!step1 || !step2) return;
    next.textContent = box.dataset.labelNext;
    const v = (name) => (form.elements[name] ? form.elements[name].value.trim() : '');
    const fill = (s, vars) => s.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));

    form.addEventListener('submit', (e) => {
      if (form.dataset.native) return;
      e.preventDefault();
      const text = fill(box.dataset.summary, { order: v('contact[Bestellnummer]'), name: v('contact[name]'), email: v('contact[email]') });
      summary.textContent = text; body.value = text;
      step1.hidden = true; step2.hidden = false;
      box.querySelector('[data-wd-ok]').focus();
    });
    box.querySelector('[data-wd-back]').addEventListener('click', () => { step2.hidden = true; step1.hidden = false; next.focus(); });
    box.querySelector('[data-wd-ok]').addEventListener('click', async (e) => {
      const native = () => { form.dataset.native = '1'; HTMLFormElement.prototype.submit.call(form); };
      if (!inline) { native(); return; }
      const btn = e.currentTarget; btn.disabled = true; msg.textContent = '';
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (/\/challenge\b/.test(res.url)) { native(); return; }
        if (!res.url.includes('contact_posted=true')) throw new Error('not posted');
        step2.hidden = true;
        const done = document.createElement('p');
        done.className = 'note wd-done'; done.setAttribute('role', 'status'); done.textContent = box.dataset.done;
        form.replaceChildren(done); done.setAttribute('tabindex', '-1'); done.focus();
      } catch (err) {
        msg.textContent = box.dataset.error;
      } finally { btn.disabled = false; }
    });
  });
}

// standalone page; on the station the overlay wires its own copy with inline: true
if (!document.querySelector('.renka-station')) wireWithdrawal(document);
